import { lazy, Suspense } from 'react';
import { ErrorPage } from '@/components/error-page/error-page.tsx';
import { useRedesign } from '@/feature-flags/redesign/use-redesign.ts';
import ExplorePageV2 from './explore-page-v2';

export const ErrorBoundary = ErrorPage;

const ExplorePage = lazy(() =>
  import('./explore-page').then((module) => ({
    default: module.ExplorePage,
  })),
);

export default function HomeExplorePage() {
  const redesign = useRedesign();

  if (redesign) {
    return <ExplorePageV2 />;
  }

  return (
    <Suspense fallback={null}>
      <ExplorePage />
    </Suspense>
  );
}
